module.exports = __webpack_public_path__ + "static/media/new3.5fa523ad.png";